import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ContextService } from 'app/core/services/context.service';
import { NavigationService } from 'app/core/services/navigation.service';
import { ThemeService } from 'app/core/services/theme.service';
import { SvgIconComponent } from 'app/shared/components/atoms';
import { FeatureFlags } from 'app/shared/services/feature-flags/feature-flags.const';
import { HomeBannerComponent } from '../home-banner/home-banner.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  imports: [
    MatCardModule,
    NgFor,
    TranslateModule,
    RouterModule,
    MatIconModule,
    AsyncPipe,
    SvgIconComponent,
    HomeBannerComponent,
    NgIf,
  ],
})
export class HomeComponent {
  protected readonly navigationService = inject(NavigationService);
  protected readonly contextService = inject(ContextService);
  protected readonly themeService = inject(ThemeService);

  public isDarkMode = this.themeService.darkMode$;
  public showHomePageTiles = this.contextService.isFeatureFlagEnabled(FeatureFlags.HomePageTiles);
  public navigationSections$ = this.navigationService.navigationItems$;
}
